import Star from "@/public/icons/star";
import { IconContainerProps } from "@mui/material";

export const IconContainer = ({ value, ...other }: IconContainerProps) => {
    return (
        <span {...other}>
            <Star />
        </span>
    );
};
